import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Icon, Table, Card, Button, Popup, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';

class ParametersList extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.ParametersList,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.search();
  }

  search() {
    this.props.deleteParametersData();
    this.props.fetchSystemParameters();
  }

  canEdit() {
    return hasAccessPermission(this.props.permissions, resources.ParametersList, scopes.Edit);
  }

  renderSearchButton() {
    if (!this.canEdit()) {
      return null;
    }
    return (
      <Button
        primary
        className='toyota-primary'
        as={Link}
        to={paths.ParametersNew}
      >
        Añadir nuevo
      </Button>
    );
  }

  renderLoadOrParameters() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderParameters();
  }

  render() {
    return (
      <div className='set-sales-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento Parámetros</h2>
              <div className='title-bar-actions'>
                {this.renderSearchButton()}
              </div>
            </div>
          </div>
        </Card>
        <Card fluid raised>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Descripción
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Valor</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Acción</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderLoadOrParameters()}</Table.Body>
          </Table>
        </Card>
      </div>
    );
  }

  renderParameters() {
    const {listParameters} = this.props;
    return listParameters.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.description}</Table.Cell>
          <Table.Cell textAlign='center'>{element.value}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Popup
              trigger={
                <Link to={`/parametro/editar/${element.code}`}>
                  <Icon name={this.canEdit() ? 'write' : 'eye'} color='blue' size='large' />
                </Link>
              }
              content={this.canEdit() ? 'Editar' : 'Ver'}
              position='top center'
              inverted
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.parameters.loading,
    'listParameters': state.parameters.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {fetchSystemParameters, deleteParametersData, navigateTo} = Actions;

export default connect(mapStateToProps, {
  fetchSystemParameters,
  deleteParametersData,
  navigateTo,
})(ParametersList);
